var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto p-16 relative text-center"},[_c('p',{staticClass:"font-thin text-xl text-gray-600"},[_vm._v("\n        "+_vm._s(_vm.$t('table.empty'))+"\n    ")]),_vm._v(" "),_vm._t("button")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }